/* One continuous vector background, recalculated when the native cart changes height. */
(()=>{
  const stage=document.querySelector('.loosy-lp8-page .stage');if(!stage)return;
  const ns='http://www.w3.org/2000/svg';
  let svg=stage.querySelector('.lr-backdrop');
  if(!svg){svg=document.createElementNS(ns,'svg');svg.classList.add('lr-backdrop');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');stage.prepend(svg);}
  let frame=0,seenW=0,seenH=0;
  function draw(){
    frame=0;const rect=stage.getBoundingClientRect();if(!rect.width)return;
    /* viewBox は使わない。SVG の中の1単位＝画面の1px にする。
       viewBox（+ preserveAspectRatio="none"）だと、書いたときの高さと今の高さの比で
       縦だけが引き伸ばされる。ページは読み込んだあとにも伸びるので、下へ行くほど
       背景がずれていく（実測：幅390pxで縦1.0739倍・最下部906px）。
       高さに依存しない描き方にすれば、描き直しが遅れても伸びは起きない（2026/10/14） */
    svg.removeAttribute('viewBox');svg.removeAttribute('preserveAspectRatio');
    svg.replaceChildren();
    const defs=document.createElementNS(ns,'defs');svg.append(defs);
    const blend=(name,a,b,y1,y2)=>{const g=document.createElementNS(ns,'linearGradient');g.id='lr-'+name;g.setAttribute('gradientUnits','userSpaceOnUse');g.setAttribute('x1','0');g.setAttribute('x2','0');g.setAttribute('y1',y1);g.setAttribute('y2',y2);for(const [offset,color] of [['0',a],['1',b]]){const stop=document.createElementNS(ns,'stop');stop.setAttribute('offset',offset);stop.setAttribute('stop-color',color);g.append(stop)}defs.append(g);return `url(#lr-${name})`;};
    const heroTail=blend('hero-tail','#eee3d5','#f7f5f0',1470,1850);
    const blue=blend('blue','#f1ebe2','#e1e8ec',-160,120);
    const green=blend('green','#ece6df','#e5e7db',-180,240);
    const compactTail=blend('compact-tail','#eee6dc','#f7f5f0',1558,1820);
    // Explicit paths follow the supplied design. Each path is drawn once on the
    // page canvas: no cropped section images and no mismatched edge endpoints.
    const at=(id,width,d,fill,stroke)=>{
      const el=document.getElementById(id);if(!el)return;
      const y=el.getBoundingClientRect().top-rect.top;
      const path=document.createElementNS(ns,'path');
      path.setAttribute('d',d);path.setAttribute('transform',`translate(0 ${y}) scale(${rect.width/width})`);
      path.setAttribute('fill',fill||'none');if(stroke){path.setAttribute('stroke',stroke);path.setAttribute('stroke-width','2');}svg.append(path);
    };
    at('design_hero',941,'M685 0L941 0L941 261C890 261 869 185 810 167C743 148 685 104 685 0Z','#e9ddcb');
    at('design_hero',941,'M0 470C91 470 91 578 137 612C192 650 267 668 240 745C221 798 142 906 0 906L0 470Z','#dedccb');
    at('design_hero',941,'M941 670C836 670 777 820 719 978L279 1505C304 1582 216 1645 265 1672C376 1733 663 1608 736 1670C777 1706 764 1868 941 1868L941 670Z',heroTail);
    at('design_points',941,'M941 1510C896 1614 780 1573 777 1672C774 1747 940 1714 941 1870',null,'#e2d7c8');
    at('design_compact',941,'M0 -118C88 -118 314 -98 285 0C274 62 167 77 132 139C94 212 77 250 0 250L0 -118Z','#eee5db');
    at('design_compact',941,'M941 199C799 199 813 374 749 483C697 569 500 419 309 448C204 466 100 571 0 571L0 705C169 705 312 774 468 876C665 1003 629 1177 747 1230C820 1260 869 1323 941 1323L941 199Z','#eee7dd');
    at('design_compact',941,'M941 1824C904 1827 866 1830 829 1829C809 1828 788 1825 769 1820C755 1816 740 1809 728 1800C718 1792 709 1780 704 1768C696 1748 696 1726 696 1705C696 1683 696 1661 704 1641C709 1627 718 1615 728 1605C740 1594 754 1585 769 1578C788 1570 809 1564 829 1560C866 1552 904 1549 941 1546Z',compactTail);
    at('design_comfort',941,'M0 -200C110 -200 290 -150 320 -30C345 85 235 160 175 250C112 345 68 420 0 420L0 -200Z',blue);
    at('design_comfort',941,'M941 326C876 326 852 393 821 451C790 509 782 546 815 574C848 602 890 677 941 677L941 326Z','#e3e9ec');
    at('design_comfort',941,'M0 1614C70 1614 185 1651 237 1687C293 1725 246 1785 172 1803C112 1817 56 1855 0 1855L0 1614Z','#ece6df');
    at('design_comfort',941,'M941.0 1451.0C933.1 1458.1 925.4 1465.5 917.3 1472.4C909.3 1479.4 900.9 1486.0 892.6 1492.8C884.4 1499.6 875.9 1506.2 867.9 1513.1C859.8 1520.1 851.8 1527.1 844.2 1534.6C836.5 1542.0 829.2 1549.7 822.1 1557.6C814.9 1565.5 808.1 1573.8 801.2 1581.9C794.3 1590.1 787.5 1598.4 780.6 1606.5C778.7 1608.8 776.5 1610.9 774.8 1613.3C773.1 1615.7 771.6 1618.3 770.4 1621.0C769.1 1623.7 768.1 1626.5 767.4 1629.4C766.7 1632.3 766.3 1635.2 766.1 1638.2C765.9 1641.2 766.0 1644.2 766.4 1647.1C766.8 1650.0 767.4 1653.0 768.3 1655.8C769.2 1658.6 770.4 1661.3 771.8 1664.0C773.3 1666.6 774.9 1669.0 776.8 1671.3C778.7 1673.6 780.9 1675.7 783.0 1677.7C790.2 1684.4 797.8 1690.7 804.9 1697.5C812.1 1704.4 818.8 1711.6 825.8 1718.6C832.8 1725.6 839.5 1732.8 846.7 1739.6C853.8 1746.5 861.0 1753.2 868.5 1759.5C876.1 1765.9 883.9 1771.9 891.8 1777.7C899.8 1783.5 908.1 1788.9 916.3 1794.5C924.5 1800.0 932.8 1805.5 941.0 1811.0Z','#e1e8eb');
    at('design_mood',941,'M0 -190C120 -190 300 -140 330 -25C356 95 240 175 178 262C112 355 70 430 0 430L0 -190Z',green);
    at('design_mood',941,'M941 388C830 388 820 558 713 600C660 622 672 680 740 710C820 746 892 788 941 788L941 388Z','#edf0e5');
    at('design_mood',941,'M941 1267C838 1267 772 1306 711 1404C648 1508 773 1660 941 1660L941 1267Z','#e8eadc');
    at('design_mood',941,'M0 1428C64 1428 229 1442 208 1514C200 1559 122 1570 96 1615C69 1669 56 1696 0 1696L0 1428Z','#e6e7d8');
    at('design_room',1029,'M0 -37C157 -37 192 57 167 128C132 223 170 277 0 277L0 -37Z','#ece7df');
    /* 下のショールームの塊へつなぐ。これが無いと AR の下で背景が途切れて、
       いきなり塊が現れる（2026/10/14） */
    at('design_room',1029,'M1029 460C880 460 744 772 766 988C788 1204 902 1528 1029 1528L1029 460Z','#eee7de');
    at('s7',1003,'M1003 -280C862 -280 725 -230 540 -220C385 -212 279 -173 315 0C357 139 462 113 511 134C564 156 532 270 670 278C815 289 905 480 1003 480L1003 -280Z','#eee7de');
    at('s7',1003,'M0 175C130 175 81 322 173 367C258 409 353 418 293 542C222 650 39 732 0 732L0 175Z','#eee7de');
    at('s7',1003,'M1003 1440C890 1440 801 1484 831 1545C855 1601 932 1644 1003 1644L1003 1440Z','#eee6db');
    seenW=rect.width;seenH=stage.scrollHeight;
  }
  /* requestAnimationFrame は裏に回ったタブでは止まる。背景が1枚も描かれないまま
    残ることがあるので（実測）、タブが見えていなくても必ず走る setTimeout を使う */
 const schedule=()=>{if(!frame)frame=setTimeout(draw,16)};
  new ResizeObserver(schedule).observe(stage);
  window.addEventListener('resize',schedule,{passive:true});document.addEventListener('shopify:section:load',schedule);document.addEventListener('shopify:section:reorder',schedule);
  /* ResizeObserver は裏に回ったタブでは通知が来ない。rAF と同じ（実測で初回通知すら
     届かない）。裏で開いたまま画像とフォントが届くと、そのあと表に戻しても背景は
     ずれたまま居座る。だから「高さか幅が変わっていたら描き直す」番犬を setInterval で
     回す。setInterval は裏でも（遅くなるだけで）走る。読むのは2つの数字だけ */
  setInterval(()=>{const r=stage.getBoundingClientRect();if(r.width!==seenW||stage.scrollHeight!==seenH)schedule();},1000);
  document.addEventListener('visibilitychange',schedule);
  window.addEventListener('load',schedule);
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(schedule);
  stage.addEventListener('load',schedule,true);
  const anchor=document.getElementById('s7');if(anchor&&!document.getElementById('sec-s7')){const marker=document.createElement('span');marker.id='sec-s7';anchor.prepend(marker);}
  const chips=document.getElementById('chips'),copySource=document.querySelector('[data-lr-fabric-copy]');
  if(chips&&copySource){
    let copy={};try{copy=JSON.parse(copySource.textContent)}catch{}
    const applyCopy=()=>chips.querySelectorAll('.mat').forEach(row=>{
      const heading=row.querySelector('.l b');if(!heading)return;
      const key=row.dataset.lrFabric||heading.textContent;const fields=copy[key];if(!fields)return;row.dataset.lrFabric=key;
      for(const [selector,value] of [['.l b',fields.title],['s',fields.description],['i',fields.badge]]){const el=row.querySelector(selector);if(el&&el.textContent!==value)el.textContent=value;}
    });
    new MutationObserver(applyCopy).observe(chips,{childList:true,subtree:true});applyCopy();
  }
  schedule();
})();

/* Preserve native editor blocks, while grouping the three scenes for visitors. */
(()=>{
 const stage=document.querySelector('.loosy-lp8-page .stage');if(!stage)return;
 const scenes=[['design_morning','7:00'],['design_evening','19:00'],['design_night','22:00']];
 const reduced=()=>window.matchMedia('(prefers-reduced-motion: reduce)').matches;
 let wrapper,viewport,controls,status,slides=[],active=0,raf=0;
 /* 自動送り。カルーセルが6割見えた時点から数えはじめ、まず1.2秒で1回送って
    “ここは動く”と知らせ、以降は4.5秒ごとに次の時間帯へ進む。
    最後まで行ったら先頭に戻る。
    画面に入っているかは毎回その場で測る（交差監視だとタブが裏にいるあいだ通知が来ず、
    戻っても止まったままになる）。TICK は 250 → **150** に詰めた。
    見えはじめの気づきと送りの判定の両方が TICK 刻みなので、250 だと最大0.75秒
    遅れて出る。早い2回で稼いだぶんがそこで消える。
    触っているあいだは止め、指が離れたら数秒おいて再開する。
    **以前は pointerdown で永久に停止していた（auto.stopped）。スマホで下へスワイプする
    とき指がカルーセルの上を通るだけで、そこから先ずっと止まっていた（2026/10/14 修正）。**
    動きを減らす設定の人と、カスタマイザーで編集中は動かさない。 */
 /* **最初の2回を早くして、3場面を見せきってから読ませる間隔に移る。**
    きえ 2026/10/14「狙いは、一旦情報を理解しつつ、自動でスクロールして
    そのセクションを通り過ぎる前に内容を見せること」。

    画面にいる時間は有限で、しかも短い。実測（375×812）：
      カルーセルの高さ 667px ＝ 画面の82%
      SEEN ぶん見えている間にスクロールできる距離 879px
      ふつうの速さ（約300px/秒）で読み流す人の持ち時間 ≒ 2.9秒
    旧 1.2 + 3.0 + 3.0 = **7.2秒** かけて3場面目に着いていた。間に合っていない。
    新 1.0 + 1.7 =       **2.7秒** で3場面目まで出し切る。そのあとは3.0秒へ戻す。

    各スライドは Before/After の写真4枚＋88〜141字。**自動送りで全文は読めない**
    （日本語は毎秒7〜10字なので141字に15〜20秒かかる）。
    役目は「3つの場面がある」と示すところまで。読む人は指を止めるので、
    止めた人には4回目以降の3.0秒が効く。 */
 /* 送りそのものの速さ。以前はブラウザ任せ（scrollTo の behavior:'smooth'）にしていた。
 ブラウザ任せの速さは距離で決まるうえ、この枠は scroll-snap-type:x mandatory と
 scroll-snap-stop:always が効いているので、動いている途中で吸着が割り込む。
 結果、ぬるっと流れるだけの動きになって「ここは横に動かせる」と伝わらなかった
 （きえ 2026/10/14「遅すぎて、目に入った瞬間にスクロールできることがわからない」）。
 自分で時間を決めて動かす。出だしを速くする曲線にして、動いた瞬間を目に入れる。
 **間隔（FIRST/STEP）は変えていない。** 直すのは1回の動きにかかる時間だけ。 */
 const GLIDE=280;
 const FIRST=1000, SECOND=1700, STEP=3000, HOLD_AFTER_TOUCH=2000, HOLD_AFTER_PRESS=6000, TICK=150;
 const auto={timer:0,down:false,holdUntil:0,wasOn:false,shown:0,last:0};
 const canAuto=()=>!reduced()&&!(window.Shopify&&window.Shopify.designMode)&&slides.length>1;
 /* 見えている割合で判定する。「全体が収まったら」にすると、下から入ってきて
    収まりきるまで何も起きず、そのあいだに通り過ぎられる（2026/10/14 実測）。
    画面より高いときは画面に入る量で測る。
    **6割から4.5割へ下げた。** 持ち時間を増やすため。6割だと数えはじめが遅く、
    読み流す人の持ち時間が2.3秒しかない。4.5割なら2.9秒になる（上の計算）。
    これ以上下げると、下端が少し覗いただけで動きはじめて、見ていない人の前で
    1周を使い切ってしまう。 */
 const SEEN=.45;
 const onScreen=()=>{const r=viewport.getBoundingClientRect();
  const vis=Math.min(r.bottom,innerHeight)-Math.max(r.top,0);
  return vis>0&&vis>=Math.min(r.height,innerHeight)*SEEN;};
 const autoHold=ms=>{auto.holdUntil=Date.now()+ms;};
 const autoStart=()=>{
  if(auto.timer||!canAuto())return;
  auto.timer=setInterval(()=>{
   /* **条件が崩れてもタイマーを捨てない。** 以前は autoStop() で止めていたが、
      一度捨てると mount() がもう一度走るまで誰も再開させない。
      mount() は DOM が動いたときにしか走らないので、動きの無いページでは永久に止まる。
      本番で「読み込んだ直後は自動送りが始まらない」が実際に出た（2026/10/15 実測。
      再現率は3回に1回ほど）。見送るだけにして、条件が戻れば次の刻みで動き出す。 */
   if(!canAuto()){auto.wasOn=false;return;}
   const now=Date.now();
   if(document.hidden||!onScreen()){auto.wasOn=false;return;}
   if(!auto.wasOn){auto.wasOn=true;auto.shown=0;auto.last=now;return;} /* 見えた時点から数えはじめる */
   if(auto.down||now<auto.holdUntil){auto.last=now;return;} /* 触っているあいだは数え直す */
   /* 1回目＝合図、2回目＝3場面目を出し切る、3回目以降＝読ませる間隔。
      画面から外れて戻ってきたら wasOn が落ちて shown も0に戻り、また早い2回から始まる */
   if(now-auto.last<(auto.shown===0?FIRST:auto.shown===1?SECOND:STEP))return;
   auto.last=now;auto.shown++;
   const next=active+1>=slides.length?0:active+1;
   go(next,next===0);   /* 先頭に戻るときだけ一気に。長い逆走を見せない */
  },TICK);
 };
 const sceneSection=id=>{const el=document.getElementById(id);return el?(el.closest('.shopify-section')||el):null;};
 function sync(){
  if(!viewport||!slides.length||!viewport.clientWidth)return;
  active=Math.max(0,Math.min(slides.length-1,Math.round(viewport.scrollLeft/viewport.clientWidth)));
  controls.querySelectorAll('.lr-day-dot').forEach((b,i)=>b.setAttribute('aria-pressed',String(i===active)));
  controls.querySelector('[data-step="-1"]').disabled=active===0;
  controls.querySelector('[data-step="1"]').disabled=active===slides.length-1;
  slides.forEach((s,i)=>{s.inert=i!==active;});
  const message=`${slides[active].dataset.sceneTime}：${active+1} / ${slides.length}`;
  if(status.textContent!==message)status.textContent=message;
 }
 /* 吸着は動かしているあいだだけ切る。付けたままだと、こちらが決めた位置へ寄せる途中で
    ブラウザが別の面へ吸い寄せ、動きが止まったり跳ねたりする。終わったら必ず戻す。

    **ここで requestAnimationFrame を使ってはいけない（落とし穴1）。**
    2026/10/15 に一度 rAF で書いて本番へ出し、壊した。描画が止まっている環境では
    rAF のコマが1枚も来ないので、go() の中の動きが始まったまま終わらない。
    外から見ると「active も shown も進んでいるのに画面が1ミリも動かない」状態になる
    （覗き窓で実測：shown 2→3→4 と進むのに scrollLeft は0のまま）。
    setInterval は遅くなるだけで必ず走り、経過時間から進み具合を出すので、
    刻みが粗いときは途中を飛ばして終点に着く。止まることがない。 */
 let glide=0;
 const glideStop=()=>{if(!glide)return;clearInterval(glide);glide=0;viewport.style.scrollSnapType='';};
 const glideEnd=()=>{glideStop();viewport.scrollLeft=active*viewport.clientWidth;sync();};
 document.addEventListener('visibilitychange',()=>{if(document.hidden)glideEnd();});
 function go(index,instant=false){
  if(!slides.length)return;
  active=Math.max(0,Math.min(slides.length-1,index));
  const to=active*viewport.clientWidth;
  glideStop();
  if(instant||reduced()){viewport.scrollLeft=to;sync();return;}
  const from=viewport.scrollLeft,delta=to-from;
  if(!delta){sync();return;}
  const t0=Date.now();
  viewport.style.scrollSnapType='none';
  glide=setInterval(()=>{
   const p=Math.min(1,(Date.now()-t0)/GLIDE);
   viewport.scrollLeft=from+delta*(1-Math.pow(1-p,3));  /* 出だしが速い曲線 */
   if(p>=1){glideStop();viewport.scrollLeft=to;sync();}
  },16);
 }
 function mount(){
  raf=0;
  const available=scenes.map(([id,time])=>({el:sceneSection(id),id,time})).filter(s=>s.el);
  if(!available.length)return;
  if(!wrapper||!wrapper.isConnected){
   wrapper=document.createElement('section');wrapper.className='lr-day-carousel';wrapper.id='loosy-day-carousel';
   wrapper.setAttribute('aria-label','LOOSYと過ごす1日');wrapper.setAttribute('aria-roledescription','カルーセル');
   viewport=document.createElement('div');viewport.className='lr-day-viewport';viewport.id='loosy-day-viewport';
   viewport.setAttribute('tabindex','0');viewport.setAttribute('aria-label','左右にスワイプして時間帯を切り替え');
   controls=document.createElement('div');controls.className='lr-day-controls';
   status=document.createElement('span');status.className='lr-day-status';status.setAttribute('aria-live','polite');status.setAttribute('aria-atomic','true');
   wrapper.append(viewport,controls,status);available[0].el.before(wrapper);
   viewport.addEventListener('scroll',sync,{passive:true});
   viewport.addEventListener('keydown',e=>{if(e.target!==viewport)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(active+(e.key==='ArrowRight'?1:-1));}});
   controls.addEventListener('click',e=>{const b=e.target.closest('button');if(!b)return;go(b.dataset.step?active+Number(b.dataset.step):Number(b.dataset.index));});
   new ResizeObserver(()=>go(active,true)).observe(viewport);
   /* 触っているあいだだけ止める。離したら数秒おいて再開（永久停止はしない） */
   viewport.addEventListener('pointerdown',()=>{auto.down=true;},{passive:true});
   for(const ev of ['pointerup','pointercancel','pointerleave'])
    viewport.addEventListener(ev,()=>{auto.down=false;autoHold(HOLD_AFTER_TOUCH);},{passive:true});
   controls.addEventListener('click',()=>autoHold(HOLD_AFTER_PRESS));
   viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft')autoHold(HOLD_AFTER_PRESS);});
  }
  const changed=slides.length!==available.length||available.some((s,i)=>s.el!==slides[i]);
  for(const [i,s] of available.entries()){
   s.el.classList.add('lr-day-slide');s.el.dataset.sceneTime=s.time;s.el.setAttribute('role','group');
   s.el.setAttribute('aria-roledescription','スライド');s.el.setAttribute('aria-label',`${s.time}：${i+1} / ${available.length}`);
   if(viewport.children[i]!==s.el)viewport.insertBefore(s.el,viewport.children[i]||null);
  }
  slides=available.map(s=>s.el);
  if(changed){
   controls.replaceChildren();
   const button=(label,kind,value)=>{const b=document.createElement('button');b.type='button';b.className=kind==='step'?'lr-day-arrow':'lr-day-dot';b.dataset[kind]=value;b.setAttribute('aria-controls',viewport.id);b.textContent=label;return b;};
   const prev=button('‹','step','-1');prev.setAttribute('aria-label','前の時間帯');controls.append(prev);
   available.forEach((s,i)=>{const b=button(s.time,'index',String(i));b.setAttribute('aria-label',`${s.time}の過ごし方を見る`);controls.append(b);});
   const next=button('›','step','1');next.setAttribute('aria-label','次の時間帯');controls.append(next);
   go(active,true);
  }
  sync();
  autoStart();
 }
 /* 背景と同じ理由で setTimeout。裏タブで開くとカルーセルが組み上がらない */
 const schedule=()=>{if(!raf)raf=setTimeout(mount,16);};
 new MutationObserver(schedule).observe(stage,{childList:true,subtree:true});
 document.addEventListener('shopify:section:load',schedule);
 document.addEventListener('shopify:section:reorder',schedule);
 for(const event of ['shopify:section:select','shopify:block:select'])document.addEventListener(event,e=>{
  mount();const i=slides.findIndex(s=>s===e.target||s.contains(e.target));if(i!==-1)go(i,true);
 });
 mount();
 /* 番犬。タイマーが落ちていたら掛け直す。
    mount() の最後の autoStart() が canAuto() の偽のときに空振りすると、
    そのあと DOM が動かないかぎり誰も掛け直さない。背景SVGと同じ考え方で見張る。
    setInterval は裏タブでも（遅くなるだけで）走る。読むのは真偽値ひとつ */
 setInterval(()=>{if(!auto.timer)autoStart();},1000);
})();

/* JSが出す文言の差し替え。loosy-lp7.js の中にベタ書きされている文字列は schema の
   設定項目にできないので、描画されたあとに置き換えている。
   弱点は「元の文字列と完全一致でないと効かない」こと。lp7.js の文言が1文字変わると
   黙って外れるので、エディタで開いているときだけ、効いていない登録を知らせる。 */
(()=>{
 const source=document.querySelector('[data-lr-commerce-copy]');if(!source)return;
 let map;try{map=JSON.parse(source.textContent)}catch{return}
 const entries=Object.entries(map).filter(([from,to])=>typeof to==='string'&&from!==to).sort((a,b)=>b[0].length-a[0].length);
 if(!entries.length)return;
 const seen=new WeakMap();let frame;
 const apply=()=>{
   frame=0;
   for(const scope of document.querySelectorAll('.lp2-sec,#cd,.stickybar,#wp-dlg')){
     const walker=document.createTreeWalker(scope,NodeFilter.SHOW_TEXT);
     while(walker.nextNode()){
       const node=walker.currentNode;if(node.parentElement.closest('script,style,[hidden],.swbank'))continue;
       const prior=seen.get(node);if(prior?.last===node.textContent)continue;
       const original=node.textContent;let next=original;
       for(const[from,to]of entries)next=next.split(from).join(to);
       seen.set(node,{original,last:next});if(next!==original)node.textContent=next;
     }
   }
 };
 /* rAF は裏に回ったタブで止まる。差し替えが走らないまま残るので setTimeout を使う */
 const queue=()=>{if(!frame)frame=setTimeout(apply,0)};
 new MutationObserver(queue).observe(document.querySelector('.stage'),{childList:true,subtree:true,characterData:true});
 const tail=document.querySelector('#cd');if(tail)new MutationObserver(queue).observe(tail,{childList:true,subtree:true,characterData:true});
 document.addEventListener('shopify:section:load',queue);apply();
 /* 効いていない登録の見張り。カスタマイザーで開いているときだけ、1回だけ調べる。
    **「見つからない」では判定しない。** 118件のうち多くは状態依存で、カートが空なら
    「LOOSY ビーズソファ」は出ないし、「← 非表示」「／ 切り抜き」は編集ツールのボタンで
    表側には出ない。空のカートで開くだけで10件が誤報されていた（2026/10/14 修正）。
    本当の失敗は「差し替えたのに元の文字列が残っている」ほうなので、そちらで見る。
    置き換え後の文字列が元を含むもの（例 送料無料 → 送料無料（沖縄除く））は対象外。 */
 if(window.Shopify&&window.Shopify.designMode)setTimeout(()=>{
  let text='';
  for(const scope of document.querySelectorAll('.lp2-sec,#cd,.stickybar,#wp-dlg'))text+=scope.textContent;
  const lost=entries.filter(([from,to])=>!String(to).includes(from)&&text.includes(from)).map(([from])=>from);
  if(!lost.length)return;
  const box=document.createElement('div');
  box.style.cssText='position:fixed;left:8px;bottom:8px;z-index:9999;max-width:min(92vw,420px);padding:10px 12px;background:#fff4f4;border:1px solid #d9a8a8;color:#8a3b3b;font-size:12px;line-height:1.7;border-radius:4px;box-shadow:0 2px 8px rgba(0,0,0,.12)';
  box.textContent='文言の差し替えが'+lost.length+'件、効いていません（元の文字列が残っています）：'+lost.slice(0,6).join(' / ')+(lost.length>6?' ほか':'')+'　※この知らせはカスタマイザーだけに出ます';
  document.body.append(box);
 },2500);
})();

/* FVのレビュー点数・件数。数字を取ってくるのは loosy-lp7.js（ad19/ad21/ad23と同じ処理）で、
   読み取った結果は #fvscore-fb に「★4.6（202件のレビュー）」の形で入る。
   lp8 はそれを受け取って、FVのカンバスの2ブロック（点数・件数）へ分けて流すだけ。
   対象は「自動で入る中身」を選んだ文字ブロック（data-role="score" / "count"）。
   LEEEPが答えるまではカスタマイザーに入っている文章がそのまま出る（＝控え）。 */
(()=>{
 const sink=document.getElementById('fvscore-fb');if(!sink)return;
 const pick=role=>document.querySelector('.lr-copy[data-role="'+role+'"]');
 if(!pick('score')&&!pick('count'))return;
 const body=el=>el&&(el.querySelector('p')||el);
 const apply=()=>{
  const m=(sink.textContent||'').replace(/\s/g,'').match(/([0-9]+(?:\.[0-9]+)?)[^0-9]*?([0-9,]+)件/);
  if(!m)return;
  const s=body(pick('score')),c=body(pick('count'));
  if(s)s.innerHTML='★<strong>'+m[1]+'</strong>';
  if(c)c.innerHTML='（'+m[2]+'件のレビュー）';
 };
 new MutationObserver(apply).observe(sink,{childList:true,characterData:true,subtree:true});
 apply();
 /* エディタでセクションを描き直すと控えの文章に戻るので、分かっている数字を入れ直す */
 document.addEventListener('shopify:section:load',()=>setTimeout(apply,0));
})();

/* LOOSY のよみがな（ルージー）を、カンバスの文字レイヤー全部に振る。
   きえ 2026/10/14「本文にも全部ルビ振りたい」「2行のときは次の行に重ならないように」

   ■ なぜ標準の <ruby> にしたか
   はじめは自前の span を position:absolute で浮かせていた。見出しが1行なら足りるが、
   2行に折り返すと次の行へ重なる（「LOOSYが選ばれる3つのポイント」で実測）。
   浮かせている以上、どこかで必ずぶつかる。標準のルビは行の下に場所を空けてから置くので、
   重なりようがない。そのかわり文字の箱は数px高くなる。
   カンバスのレイヤーは1枚ずつ top を持って置かれているため、隣の層とのすき間が
   そのぶん詰まる。出す前に全レイヤーで測ってある（CHANGELOG 2026/10/14）。

   ■ どこに振るか
   カンバスの文字レイヤー（.stage .lr-copy）にある LOOSY の全部。見出しも本文も区別しない。
   **レビュー（LEEEP）の中は対象外。** お客さまが書いた文章と商品名が30か所あり、
   そこへこちらの都合でルビを足すのは引用の書き換えになる。LEEEPは後から描き直すので
   どのみち残らない。

   ■ 二重に振らない
   すでに <ruby class="lr-yomi"> の中にある LOOSY は触らない。
   カスタマイザーがセクションを描き直したときは素の状態に戻るので、そこで振り直す。 */
(()=>{
 const stage=document.querySelector('.loosy-lp8-page .stage');if(!stage)return;
 const YOMI='ルージー', WORD='LOOSY';
 const apply=()=>{
  let added=0;
  for(const el of stage.querySelectorAll('.lr-copy')){
   if(!(el.textContent||'').includes(WORD))continue;
   const walker=document.createTreeWalker(el,NodeFilter.SHOW_TEXT);
   const hits=[];let node;
   while((node=walker.nextNode())){
    if(!node.nodeValue.includes(WORD))continue;
    if(node.parentElement&&node.parentElement.closest('.lr-yomi'))continue;  /* 振り直しの二重がけを防ぐ */
    hits.push(node);
   }
   for(const text of hits){
    let cursor=text;
    for(;;){
     const at=cursor.nodeValue.indexOf(WORD);if(at<0)break;
     const base=cursor.splitText(at);cursor=base.splitText(WORD.length);
     const ruby=document.createElement('ruby');ruby.className='lr-yomi';ruby.textContent=WORD;
     const rt=document.createElement('rt');rt.textContent=YOMI;
     rt.setAttribute('aria-hidden','true');   /* 読み上げは「LOOSY」のまま。二重に読ませない */
     ruby.append(rt);base.replaceWith(ruby);added++;
    }
   }
  }
  return added;
 };
 apply();
 /* カスタマイザーで描き直すと素の文字に戻るので振り直す。
    幅が変わっても標準のルビは自分で付いて回るので、番犬は要らない */
 document.addEventListener('shopify:section:load',()=>setTimeout(apply,0));
})();

/* 追従バーを出しはじめる位置。
   きえ 2026/10/15「開いた瞬間に購入CTAを出すと画面が埋まる。
   『LOOSYが選ばれる3つのポイント』のまとめを読んで、詳細説明に入る段階で出したい」

   ■ どこが決めているか
   帯の出し入れは **loosy-lp7.js の sbarSync** が持っている（lp8 は lp7.js をそのまま読む）。
   その中の境界はこの2行だけ：
     var s0 = document.getElementById('sec-s0');
     var afterFV = !s0 || s0.getBoundingClientRect().bottom < 0;
   ad19/ad21/ad23 は FV の節に sec-s0 があるので「FVを過ぎたら出す」になる。
   **lp8 には sec-s0 が無い。** だから !s0 が真になり、読み込んだ瞬間から帯が出ていた
   （本番実測：scrollY 0 で高さ70pxの帯が出ている）。画面の下が常に埋まる。

   ■ 直し方
   lp7.js には手を入れない（ad19/ad21/ad23 と共有していて、直すと3本とも動く）。
   **lp8 だけ、3つのポイントの節の「終わり」に sec-s0 の印を置く。**
   すると afterFV が「まとめを読み終えて詳細に入った」と一致する。

   ■ いつ出すか
   きえの指定は「**3つのまとめが画面全体に表示されたら**出していい」。
   節を通り過ぎた時点ではなく、**節が画面に収まった時点**。1画面ぶん早い。

   sbarSync が見るのは印の下端が0を切ったかどうかだけなので、印を節の底から
   「画面の高さぶん」上に浮かせる。すると
     印の下端 < 0  ⟺  節の下端 < 画面の高さ  ⟺  まとめが画面に収まった
   になる。画面の高さは端末で変わるので JS で実測して入れ、画面が変わったら入れ直す
   （100vh はスマホのアドレスバーの伸び縮みでズレるので使わない）。

   さらに帯の高さぶん（CLEAR）を引く。引かないと、出た瞬間に帯がまとめの下端へ
   かぶさる。実測で帯は70pxなので80pxの余裕を取る。

   ■ 置き方の注意
   節の中のレイヤーは全部 absolute なので、ふつうに append すると印は節の**先頭**に
   居座る。節の箱（.shopify-section）は loosy-lp8.css で position:relative なので、
   **印も absolute にして、節の底からの距離（bottom）で位置を決める**。

   ■ 置けないとき
   カスタマイザーで3つのポイントの節を消す・並べ替えるなどで `design_points` が
   見つからないときは何もしない。!s0 のままなので今までどおり最初から出る。
   「出なくなって誰も買えない」側には倒さない。 */
(()=>{
 const SECTION='design_points', MARK='sec-s0', CLEAR=80;
 /* **lp7.js は window.__sbarSync を定義していない。** lp4.js にはあるので在ると思い込んだが、
    lp8 が読むのは lp7.js のほうで、実測で undefined だった（2026/10/15）。
    lp7.js は window の scroll で sbarSync を呼んでいるので、scroll を1回投げて見直させる。
    ページは普段から scroll を山ほど受けているので、1回足しても悪さはしない。 */
 const sync=()=>{
  if(typeof window.__sbarSync==='function'){window.__sbarSync();return;}
  window.dispatchEvent(new Event('scroll'));
 };
 const put=()=>{
  const anchor=document.getElementById(SECTION);if(!anchor)return;
  const host=anchor.closest('.shopify-section')||anchor;
  let mark=document.getElementById(MARK);
  if(!mark||mark.parentElement!==host){
   if(mark)mark.remove();                             /* 別の場所にあるなら置き直す */
   mark=document.createElement('span');
   mark.id=MARK;mark.setAttribute('aria-hidden','true');
   mark.style.cssText='position:absolute;left:0;width:1px;height:1px;pointer-events:none';
   host.append(mark);
  }
  /* 節の底から「画面の高さ − 帯のぶん」だけ上に浮かせる */
  const want=Math.max(0,innerHeight-CLEAR)+'px';
  if(mark.style.bottom!==want){mark.style.bottom=want;sync();}
 };
 put();
 window.addEventListener('resize',put,{passive:true});   /* 画面の高さが変わったら貼り直す */
 /* lp7.js が帯を組み立てる前に印を置くと、最初の1回が反映されないことがある。
    数回だけ出し直しを頼む（空振りしても安い） */
 for(const ms of [0,300,1200,3000])setTimeout(sync,ms);
 document.addEventListener('shopify:section:load',()=>setTimeout(put,0));
 /* 節を描き直すと印ごと消える。番犬で見張る（rAF も ResizeObserver も裏タブでは来ない） */
 setInterval(put,1000);
})();
